import SkeletonLoader from '@/components/SkeletonLoader';

export const SchoolLicenseDetailsSkeleton = () => {
  return (
    <div className="flex flex-col gap-10 w-full h-full">
      {/* Profile Section */}
      <div className="flex flex-col items-center gap-3">
        <SkeletonLoader className="w-24 h-24" variant="circle" />
        <SkeletonLoader className="h-6 w-48" variant="text" />
        <SkeletonLoader className="h-6 w-20 rounded-full" variant="rect" />
      </div>

      {/* Contact Info */}
      <div className="grid grid-cols-3 gap-4 pt-2">
        {Array.from({ length: 3 }).map((_, i) => (
          <div key={i} className="flex items-start gap-2.5">
            <SkeletonLoader className="h-5 w-5" variant="rect" />
            <div className="flex flex-col gap-1">
              <SkeletonLoader className="h-4 w-20" variant="text" />
              <SkeletonLoader className="h-4 w-28" variant="text" />
            </div>
          </div>
        ))}
      </div>

      {/* License Overview */}
      <div className="flex flex-col gap-4">
        <SkeletonLoader className="h-5 w-40" variant="text" />
        <div className="bg-indigo-light-50 rounded-xl p-4 flex flex-col items-center justify-center gap-1">
          <SkeletonLoader className="h-3 w-24" variant="text" />
          <SkeletonLoader className="h-7 w-16" variant="text" />
        </div>
      </div>

      {/* Important Dates Box */}
      <div className="bg-brand-light-50 rounded-2xl p-6 flex flex-col gap-6 border border-neutral-light-100">
        <div className="flex items-center gap-3">
          <SkeletonLoader className="h-9 w-9 rounded-xl" variant="rect" />
          <SkeletonLoader className="h-5 w-44" variant="text" />
        </div>

        <div className="space-y-4">
          {Array.from({ length: 3 }).map((_, i) => (
            <div key={i} className="flex items-center justify-between">
              <SkeletonLoader className="h-4 w-32" variant="text" />
              <SkeletonLoader className="h-6 w-40" variant="rect" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
